<template>
<div class="app has-header">
    <div class="header">
        <menutabs :state="{tabs: tabs}" :tab-selected="tabSelected" @tab-select="UpdateSelectedView" :disabled="!allowContentSwitch"></menutabs>
    </div>
    <component v-if="tabSelected != null" :is="tabSelected.view" @switch-tabs-index="SwitchTabsByIndex"/>
    <div v-else>
        <h1 style="color: red">{{ $t('shift.main.missingPermissions') }}</h1>
    </div>
</div>
</template>

<script>



import newtemplateview from '../shiftcontext/NewTemplateView.vue'
import templategroupview from './TemplateGroupOverview.vue'
import roster from '../testroster/Roster.vue'
import vlhkanbanoverview from '../planningindicatorcontext/VlhKanbanOverview.vue'
import planningemployeethresholdoverview from '../planningindicatorcontext/PlanningEmployeeThresholdOverview.vue'
import locationoverview from '../shiftcontext/LocationOverview.vue'
import positioningoverview from '../shiftcontext/PositioningOverview.vue'
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        newtemplateview,
        templategroupview,
        locationoverview,
        roster,
        vlhkanbanoverview,
        planningemployeethresholdoverview,
        positioningoverview
    },
    name: 'ShiftMain',
    data() {
        return {
            loading: true,
            tabSelected: null,
        }
    },
    computed:{
        ...mapGetters(['storeId', 'isSuperUser', 'allowContentSwitch', 'storeSettings', 'permissions']),
        canViewRoster(){
            if (this.isSuperUser){
                return true;
            }

            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.filter(p => p.id == 13 && p.level > 1).length > 0) {

                    res = true;
                    break;
                }
            }

            return res;
        },
        tabs() {

            let tv = 'newtemplateview';
            let tabs = [];

            if(this.canViewRoster){
                tabs.push({label: this.$t('global.menubar.roster'), view: 'roster', margin: true, selected: true});
                tabs.push({label: this.$t('shift.main.plan'), view: tv, margin: true});
                tabs.push({label: this.$t('shift.main.groups'), view: 'templategroupview', margin: true});
                
            }
            tabs.push({label: this.$t('shift.main.locations'), view: 'locationoverview', margin: true, selected: !this.canViewRoster});


            if(this.storeSettings && this.storeSettings.enableVlh){
                tabs.splice(3,0,{label: this.$t('shift.main.vlh'), view: 'vlhkanbanoverview', margin: true});
            }
            if(this.storeSettings && this.storeSettings.enableMeo){
                tabs.splice(3,0,{label: this.$t('shift.main.meo'), view: 'planningemployeethresholdoverview', margin: true});
            }

            if(this.storeSettings && this.storeSettings.simpleMode){
                if(this.canViewRoster){
                    tabs = [
                        {label: this.$t('global.menubar.roster'), view: 'roster', selected: true, margin: true},
                    ];
                } else {
                    tabs = [];
                }
            }

            if(this.canViewRoster){
                tabs.push({label: this.$t('shift.main.positioning'), view: 'positioningoverview', margin: true});

            }

            return tabs;
        },
        selectedView() {
            return this.view;
        }
    },
    watch: {
        isSuperUser: {
            immediate: true,
            handler(newVal, oldVal) {
                if(newVal) {
                    this.SwitchTabsByIndex(0);
                }
            }
        }
    },
    props: ['view'],
    created() {
        let view = this;
        let tab;
        if(this.$router.currentRoute.params.tab){
            tab = this.tabs.find(t => t.view === view.$router.currentRoute.params.tab);
            if(tab == null){
                tab = this.tabs.find(t => t.selected);
            }
        } else {
            tab = this.tabs.find(t => t.selected);

        }
        if(!tab){
            //find default tab
            if(this.canViewRoster){
                tab =  {view: this.view ? this.view : 'roster'}
            } else {
                if(this.view && this.view != 'roster'){
                    tab =  {view: this.view }
                } else {
                    tab =  null;
                }

            }

        }
        if(tab){
            this.UpdateSelectedView(tab);
        }

    },
    mounted(){

    },
    updated() {},
    destroyed() {},
    methods: {
        UpdateSelectedView(tab){
            this.tabs.forEach(t => t.selected = false);
            tab.selected = true;
            this.tabSelected = tab;
            this.$store.commit("setRosterView", {rosterView: this.tabSelected.view == 'roster'});
        },
        SwitchTabsByIndex(index){
            if(this.tabs.length >index){
                let tab = this.tabs[index];
                this.UpdateSelectedView(tab);
            }

        }
    }
}
</script>
